<template>
    <div class="cotnent fix-height" @click="toggleSidebar">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <card class="card-plain">
                        <form dir="rtl" @submit.prevent="submitForm">
                            <div class="form-group" style="text-align: right;">
                                <label for="title" class="formInput">عنوان:</label>
                                <input type="text" class="form-control formInput" id="title"
                                    placeholder="عنوان را وارد کنید">
                                <label for="image" class="formInput">افزودن عکس:</label>
                                <input type="file" class="form-control formInput" id="imagePreviewInput" accept="image/*"
                                    @change="previewImage($event)" placeholder="عکس مد نظر خود را انتخاب کنید">
                                <!-- Image preview container -->
                                <div id="imagePreviewContainer" style="display: none; text-align: center;">
                                    <img id="imagePreview" alt="Selected Image Preview">
                                </div>
                                <label for="description" class="formInput">توضیحات:</label>
                                <textarea class="form-control textarea" id="description" rows="6"></textarea>
                                <div class="row">
                                    <label for="tags" class="formInput">برچسب ها:</label>
                                    <p class="link" @click="add_skill">افزودن برچسب جدید به پایگاه داده</p>
                                </div>
                                <div class="form-control formInput tagsArea" id="tags_holder">
                                    <p v-for="skill in selected_skills" :key="skill.id" class="tag"
                                        @click="removeTag(skill.id)">{{ skill.name }}
                                        <i class="fa fa-times" aria-hidden="true" style="color: red;"
                                            @click="removeTag(skill.id)"></i>
                                    </p>
                                    <p v-if="selected_skills.length === 0">حداقل یک برچسب انتخاب کنید</p>
                                </div>
                                <select class="form-control formInput" id="tags" @change="selectTags">
                                    <option>انتخاب کنید</option>
                                    <option v-for="skill in Skills" :key="skill.id" :value="skill.id">{{ skill.name }}
                                    </option>
                                </select>
                            </div>
                            <button type="submit" class="btn btn-primary">ارسال</button>
                        </form>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { Apis } from '../constants';

export default {
    data() {
        return {
            Skills: [
            ],
            selected_skills: [
            ]
        }
    },
    mounted() {
        axios.get(Apis.get_skills, {
            withCredentials: true
        }).then(response => {
            if (response.data.result == undefined) {
                this.Skills = response.data;
            }
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        },
        previewImage(event) {
            const input = event.target;
            const preview = document.getElementById('imagePreview');

            if (input.files && input.files[0]) {
                const reader = new FileReader();

                reader.onload = function (e) {
                    // Set the source of the image to the selected file
                    preview.src = e.target.result;
                    // Show the image preview container
                    document.getElementById('imagePreviewContainer').style.display = 'block';
                };

                // Read the selected file as a data URL
                reader.readAsDataURL(input.files[0]);
            } else {
                // Clear the image source and hide the preview container if no file is selected
                preview.src = '';
                document.getElementById('imagePreviewContainer').style.display = 'none';
            }
        },
        selectTags() {
            const selected = document.getElementById('tags');
            const selected_id = selected.options[selected.selectedIndex].value;
            const selected_name = selected.options[selected.selectedIndex].text;
            const skill = { id: selected_id, name: selected_name };
            this.selected_skills.push(skill);
            this.Skills = this.Skills.filter(item => item.id != skill.id);
        },
        removeTag(id) {
            const skill = this.selected_skills.find(skill => skill.id === id);
            this.selected_skills = this.selected_skills.filter(skill => skill.id !== id);
            this.Skills.push(skill);
        },
        validateForm() {
            const title = document.getElementById('title').value;
            const description = document.getElementById('description').value;
            const tags = this.selected_skills.length;

            if (title === '' || description === '' || tags === 0) {
                return false;
            }
            return true;
        },
        submitForm() {
            if (this.validateForm()) {
                this.$loading.show();
                console.log("lets submit form");
                let form = new FormData();
                form.append('title', document.getElementById('title').value);
                form.append('description', document.getElementById('description').value);
                form.append('image', document.getElementById('imagePreviewInput').files[0]);
                form.append('skills', this.selected_skills.map(skill => skill.id).join(','));
                axios.post(Apis.new_exp, form, {
                    withCredentials: true
                }).then(response => {
                    console.log(response);
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.$loading.hide();
                });
            } else {
                this.$notifications.notify(
                    {
                        message: `<span><b>خطا</b>, لطفا عنوان، توضیحات و برچسب را پر نمایید.</span>`,
                        icon: 'nc-icon nc-notification-70 ',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
            }
        },
        add_skill() {
            let skill = prompt('نام برچسب جدید را وارد کنید');
            if (skill) {
                let form = new FormData();
                form.append('name', skill);
                axios.post(Apis.skills_add, form, {
                    withCredentials: true
                }).then(response => {
                    this.Skills = response.data;
                    console.log(response.data);
                }).catch(error => {
                    console.log(error);
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.tagsArea {
    display: flex;
    flex-wrap: wrap;
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin: 8px;
    height: auto;

    .tag {
        margin: 5px;
        padding: 5px;
        border: 1px solid #ddd;
        border-radius: 5px;
        cursor: pointer;
    }
}

#imagePreview {
    max-height: 500px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin: 10px;
}

.formInput {
    margin: 8px;
    font-size: 16px;
}

.textarea {
    font-size: 14px;
    margin: 8px;
}


.fix-height {
    min-height: 100vh;
}

.link {
    color: #007bff;
    cursor: pointer;
    font-size: small;
    margin-top: auto;
    margin-bottom: auto;
}
</style>
